import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ManualsPrintedData,
  ExportService,
  LoggingService,
  ManualPrintedData,
} from "app/shared";
import { ManualsPrintedConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";

@Component({
  selector: "manuals-printed-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class ManualsPrintedChartComponent
  extends BaseChartLogic<ManualsPrintedConfig, ManualsPrintedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      ManualsPrintedConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.manualsPrintedDataChange);
  }

  getCustomLabel(dataPoint: ManualPrintedData, label: string): any {
    if (label !== "User Data") {
      return "";
    }
    const users = dataPoint.PrintedByUsers;
    const dictionary = dataPoint.UserIdToDatesDict;

    //build out objects of users and dates printed
    // Use all options if customLabelSelection is undefined or empty
    const customLabelSelection = this.config?.customLabelSelection?.length
      ? this.config.customLabelSelection
      : this.chartDetails.customLabels["User Data"];

    const result: any[] = [];

    users.forEach((user) => {
      const userDates = dictionary[user.Id] || [];

      const row = {};
      if (customLabelSelection.includes("User.FullName")) {
        row["FullName"] = `${user.FirstName} ${user.LastName}`;
      }

      if (customLabelSelection.includes("User.Email")) {
        row["Email"] = user.UserName;
      }

      if (customLabelSelection.includes("DatePrinted")) {
        row["DatePrinted"] = userDates
          .map((date) => new Date(date).toLocaleString())
          .join("; ")
          .replace(",", "-");
      }

      if (customLabelSelection.includes("Total")) {
        row["TotalByUser"] = userDates.length;
      }

      result.push(row);
    });
    return result;
  }

  dataPointKey: string = "Total";
  protected getDataPointDisplayValue(dataPoint: ManualPrintedData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  refreshData(): void {
    this.analyticsService.getDocumentsPrintedData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
